module.exports = __webpack_public_path__ + "static/sportex-result-1-a70733da04bc5bcaed5b5654e1234117.png";